import { ParameterType } from '@/study-search/enums';
import { FilterDefinition } from './FilterDefinition';

export class CampaignTypeFilterDefinition extends FilterDefinition {
	public constructor() {
		super(ParameterType.CAMPAIGN_TYPE, [], []);
	}
}

export default new CampaignTypeFilterDefinition();